import { type EpisodeData, type MovieData, type SeasonData, type TvData } from '../types.ts';

export const getVideos = (data: MovieData | SeasonData | TvData | EpisodeData | null | undefined) => {
  if (!data) {
    return [];
  }

  switch (true) {
    case 'movie' in data: {
      return data.movie?.videos ?? [];
    }

    case 'season' in data: {
      return data.season?.videos ?? [];
    }

    case 'episode' in data: {
      return data.episode?.videos ?? [];
    }

    case 'tv' in data: {
      return data.tv?.videos ?? [];
    }

    default: {
      return [];
    }
  }
};
